export function formatDate(date, locale = "en", options = {}) {
  if (!date) return "—";

  try {
    let dateObj;
    
    if (typeof date === "string") {
      // check if it's a date-only string (YYYY-MM-DD) without time component
      // parse manually to avoid timezone shift
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        const [year, month, day] = date.split("-");
        dateObj = new Date(year, month - 1, day); // Local timezone
      } else {
        dateObj = new Date(date);
      }
    } else {
      dateObj = date;
    }
    
    // check for invalid date
    if (isNaN(dateObj.getTime())) return "—";

    const formatOptions = {
      month: "short",
      day: "numeric",
      ...(options.short ? {} : { year: "numeric" }),
      ...(options.long ? { weekday: "long" } : {}),
    };

    return new Intl.DateTimeFormat(locale, formatOptions).format(dateObj);
  } catch {
    return "—";
  }
}

export function getRelativeTime(date, locale = "en") {
  if (!date) return "";

  try {
    let dateObj;
    
    if (typeof date === "string") {
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        const [year, month, day] = date.split("-");
        dateObj = new Date(year, month - 1, day);
      } else {
        dateObj = new Date(date);
      }
    } else {
      dateObj = date;
    }
    
    if (isNaN(dateObj.getTime())) return "";

    const now = new Date();
    const diffMs = now - dateObj;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });

    if (diffDays < 1) return rtf.format(0, "day"); // "today"
    if (diffDays < 7) return rtf.format(-diffDays, "day");
    if (diffDays < 30) return rtf.format(-Math.floor(diffDays / 7), "week");
    if (diffDays < 365) return rtf.format(-Math.floor(diffDays / 30), "month");
    return rtf.format(-Math.floor(diffDays / 365), "year");
  } catch {
    return "";
  }
}
